import React from "react";
import cn from "classnames";
import { i18n } from "@src/i18n/i18n";
import { Icon } from "@components/atoms/icon/icon";
import styles from "./info-icon-button.module.scss";

interface InfoIconButtonPropTypes {
  ariaLabel?: string;
  iconName: string;
  isIconActive: boolean;
  height?: number;
  width?: number;
  handleClick: () => void;
}

const DEFAULT_ARIA_LABEL = i18n("modules.infoButton.infoText");
const DEFAULT_ICON_NAME = "info_icon";
const DEFAULT_HEIGHT = 24;
const DEFAULT_WIDTH = 24;

const cssClassName = "info-icon-button";

export const InfoIconButton = ({
  ariaLabel = DEFAULT_ARIA_LABEL,
  iconName = DEFAULT_ICON_NAME,
  isIconActive,
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
  handleClick,
}: InfoIconButtonPropTypes) => (
  <button
    type="button"
    className={cn(
      styles[cssClassName],
      styles[`${cssClassName}__hover`],
      styles[`${cssClassName}__center-content`],
      {
        [styles[`${cssClassName}__active`]]: isIconActive,
      },
    )}
    onClick={handleClick}
    aria-label={ariaLabel}
  >
    <Icon name={iconName} width={width} height={height} />
  </button>
);
